/**
 * Implements a single item
 */
import { useCallback } from 'react';
import { ITicker, ITrendingItem } from '@kattana-io/common';
import useTickerLivePrice from '../Watchlist/useTickerLivePrice';
import { switchCurrentTicker } from '../../Authlogic';

interface ITrendingCoinProps {
  item: ITrendingItem;
}

interface ICoinWithTickerProps {
  ticker: ITicker;
  label: string;
}

const TrendingCoin = ({ item }: ITrendingCoinProps) => {
  const { label, link, price, ticker } = item;

  if (ticker) {
    return <CoinWithTicker ticker={ticker} label={label} />;
  }

  return (
    <a className='trending__item' href={link}>
      {label}&nbsp;
      {price ? (
        <span className='trending__item__price--green'>
          ${price.toFixed(2)}
        </span>
      ) : (
        ''
      )}
    </a>
  );
};

const CoinWithTicker = ({ ticker, label }: ICoinWithTickerProps) => {
  const { price, side } = useTickerLivePrice(ticker);

  const onTickerClick = useCallback(() => {
    if (ticker) {
      switchCurrentTicker(ticker);
    }
  }, [ticker]);

  return (
    <div className='trending__item' onClick={onTickerClick}>
      {label}&nbsp;
      <span
        className={
          side === 'sell'
            ? 'trending__item__price--red'
            : 'trending__item__price--green'
        }
      >
        {price}
      </span>
    </div>
  );
};

export default TrendingCoin;
